<template>
  <div class="home">
    <image-gallery></image-gallery>
  </div>
</template>

<script>
import ImageGallery from "@/components/ImageGallery.vue";
export default {
  name: "Home",
  components: {
    ImageGallery
  }
};
</script>
